import { render, staticRenderFns } from "./TATView.vue?vue&type=template&id=a9fa9a26"
import script from "./TATView.vue?vue&type=script&lang=js"
export * from "./TATView.vue?vue&type=script&lang=js"
import style0 from "./TATView.vue?vue&type=style&index=0&id=a9fa9a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports